var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintActivityUnusedBonusColorLabelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    transform: "rotate(-180 6 6)",
    fill: "url(#paint0_linear_unusedBonus)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_unusedBonus",
    x1: 11.6272,
    y1: 5.98471,
    x2: 0.019129,
    y2: 5.98471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintActivityUnusedBonusColorLabelIcon);
export default __webpack_public_path__ + "static/media/print-activity-unused-bonus-color-label-icon.81ab6d5b55c443d4eab62e872118f260.svg";
export { ForwardRef as ReactComponent };